// This script fetches the average rating and total reviews from the Reviews.io API.
// It then updates the HTML elements with the fetched data and handles the popup functionality.
document.addEventListener("DOMContentLoaded", () => {
  const containers = Array.from(
    document.querySelectorAll("[data-additional-bar]") || []
  );

  const STAR_PATH =
    "M7.52447 1.46352C7.67415 1.00287 8.32585 1.00287 8.47553 1.46353L9.68386 5.18237C9.75079 5.38838 9.94277 5.52786 10.1594 5.52786H14.0696C14.554 5.52786 14.7554 6.14767 14.3635 6.43237L11.2001 8.73075C11.0248 8.85807 10.9515 9.08375 11.0184 9.28976L12.2268 13.0086C12.3764 13.4693 11.8492 13.8523 11.4573 13.5676L8.29389 11.2693C8.11865 11.1419 7.88135 11.1419 7.70611 11.2693L4.54267 13.5676C4.15081 13.8523 3.62357 13.4693 3.77325 13.0086L4.98157 9.28976C5.04851 9.08375 4.97518 8.85807 4.79994 8.73075L1.6365 6.43237C1.24464 6.14767 1.44603 5.52786 1.93039 5.52786H5.84062C6.05723 5.52786 6.24921 5.38838 6.31614 5.18237L7.52447 1.46352Z";

  const SVG_FULL = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="${STAR_PATH}" fill="currentColor" stroke="currentColor"></path></svg>`;
  const SVG_EMPTY = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="${STAR_PATH}" fill="none" stroke="currentColor"></path></svg>`;
  const SVG_HALF = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
      <defs><clipPath id="half-clip"><rect x="0" y="0" width="50%" height="100%"></rect></clipPath></defs>
      <path d="${STAR_PATH}" fill="currentColor" stroke="currentColor" clip-path="url(#half-clip)"></path>
      <path d="${STAR_PATH}" fill="none" stroke="currentColor"></path>
    </svg>`;

  function renderStars(rating) {
    const full = Math.floor(rating);
    const half = rating - full >= 0.5;
    const empty = 5 - full - (half ? 1 : 0);
    return (
      SVG_FULL.repeat(full) + (half ? SVG_HALF : "") + SVG_EMPTY.repeat(empty)
    );
  }

  const jsonHeaders = {
    method: "GET",
    headers: { accept: "application/json" },
  };

  // 1) Company-wide stats
  fetch("https://api.reviews.io/stats/all?store=bluefarm.co", jsonHeaders)
    .then((res) => (res.ok ? res.json() : Promise.reject(res)))
    .then(({ company_review_stats } = {}) => {
      containers.forEach((container) => {
        if (container.dataset.type !== "company") return;

        const avg = parseFloat(company_review_stats?.average_rating) || 0;
        const totalRaw = company_review_stats?.total_reviews || 0;
        const total = totalRaw.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        // Stars
        const starsEl = container.querySelector(".rating-stars");
        if (starsEl) {
          starsEl.innerHTML = renderStars(avg);
        }

        // Average rating text (with comma) + optional label
        const avgEl =
          container.querySelector(".average-rating") ||
          container.querySelector(".rating-value");
        const ratingText = container.dataset.ratingText || "";
        if (avgEl) {
          avgEl.textContent =
            avg.toFixed(1).replace(".", ",") + " " + ratingText;
        }

        // Total reviews text
        const totalEl = container.querySelector(".total-reviews");
        const reviewsText = container.dataset.reviewsText || "";
        if (totalEl) {
          totalEl.textContent = total + " " + reviewsText;
        }
      });
    })
    .catch((err) => console.error("Company stats fetch error:", err));

  // 2) Per-product stats
  containers
    .filter((c) => c.dataset.type === "product")
    .forEach((container) => {
      const sku = container.dataset.reviewsSku;
      if (!sku) return;

      fetch(
        `https://api.reviews.io/product/review?store=bluefarm.co&sku=${encodeURIComponent(
          sku
        )}`,
        jsonHeaders
      )
        .then((res) => (res.ok ? res.json() : Promise.reject(res)))
        .then(({ stats = {} } = {}) => {
          const avg = parseFloat(stats.average) || 0;
          const totalRaw = stats.total_reviews || 0;
          const total = totalRaw
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

          // Stars
          const starsEl = container.querySelector(".rating-stars");
          if (starsEl) {
            starsEl.innerHTML = renderStars(avg);
          }

          // Average rating text (with comma) + optional label
          const avgEl =
            container.querySelector(".average-rating") ||
            container.querySelector(".rating-value");
          if (avgEl) {
            avgEl.textContent = avg.toFixed(1).replace(".", ",");
          }

          // Total reviews text (if present)
          const totalEl = container.querySelector(".total-reviews");
          const reviewsText = container.dataset.reviewsText || "";
          if (totalEl) {
            totalEl.textContent = total + " " + reviewsText;
          }
        })
        .catch((err) =>
          console.error(`Product stats fetch error for SKU ${sku}:`, err)
        );
    });

  // 3) Popup handlers
  const triggers = document.querySelectorAll(".additional-bar__button_popup");
  const overlays = document.querySelectorAll(".popup-overlay");

  triggers.forEach((trigger, i) => {
    const overlay = overlays[i];
    if (!overlay) return;

    trigger.addEventListener("click", () => {
      overlay.classList.add("visible");
      document.body.classList.add("overflow-hidden");
    });

    const closeBtn = overlay.querySelector(".popup-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        overlay.classList.remove("visible");
        document.body.classList.remove("overflow-hidden");
      });
    }

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        overlay.classList.remove("visible");
        document.body.classList.remove("overflow-hidden");
      }
    });
  });
});
